import { Form, FormBuilder } from "@redriver/cinnamon";
import { Heading } from "components/containers";
import React, { Fragment, useState } from "react";
import { Button } from "semantic-ui-react";
import { sendResetLink } from "./actions";
import { Link } from "react-router-dom";
import { SystemRoutes } from "constants/routes";

const ForgottenPassword = () => {
  const [isSent, setIsSent] = useState(false);
  return (
    <div>
      <Heading>Password Reset</Heading>
      <p>Please enter your email to reset your password.</p>
      <FormBuilder
        submitAction={sendResetLink}
        onSubmitted={() => setIsSent(true)}
        renderForm={(formProps, state, events) => (
          <Form {...formProps}>
            {isSent ? (
              <p>
                An email has been sent to you, please follow the instructions to
                finish resetting your password
              </p>
            ) : (
              <Fragment>
                <Form.Email field="email" placeholder="Email" required />
                <Button
                  className="rounded-button"
                  primary
                  onClick={events.onSubmit}
                  loading={state.submitting}
                >
                  Reset Password
                </Button>
              </Fragment>
            )}
          </Form>
        )}
      />
      <div style={{ marginTop: "1em" }}>
        <Link to={SystemRoutes.Login}>Back to login</Link>
      </div>
    </div>
  );
};

export default ForgottenPassword;
